import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

import { emissionValueWithDecimals } from '../../../../../../../../../../../shared/helpers/emission-value-with-decimals';
import { IMachine, OperationMode } from '../../../PcfWizard.type';
import styles from '../CalculationDetails.module.css';

type AuxiliaryEquipmentValuesProps = {
  machine: IMachine;
};

const AuxiliaryEquipmentValues = ({ machine }: AuxiliaryEquipmentValuesProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-column w-full gap-3'>
      <div
        className={classNames(styles['auxiliary-equipment-name'], 'py-1 px-2 w-fit font-medium')}
      >
        {machine?.name}
      </div>

      <div className='grid w-full grid-nogutter'>
        {/* Operating Power */}
        <div className='col-6 flex flex-column gap-1 pr-2'>
          <span className='text-gray-700 font-medium'>
            {t(
              'calculationDetailsPage.sections.injectionMoldingProcess.auxiliaryEquipments.ratedPower',
            )}
          </span>
          <div className='flex flex-row gap-1 text-lg'>
            <span className='text-lg'>{machine?.rated_power}</span>
            <span>kW</span>
          </div>
        </div>

        {/* Energy per Piece */}
        <div className='col-6 flex flex-column gap-1 pl-2'>
          <span className='text-gray-700 font-medium'>
            {t(
              'calculationDetailsPage.sections.injectionMoldingProcess.auxiliaryEquipments.energyPerPiece',
            )}
          </span>
          <div className='flex flex-row gap-1 text-lg'>
            <span className='text-lg'>{emissionValueWithDecimals(machine?.energy_per_piece)}</span>
            <span>kWh</span>
          </div>
        </div>
      </div>

      {/* Cycle Time */}
      {machine.operation_mode === OperationMode.HANDLING_TIME && (
        <div className='flex flex-column gap-1'>
          <span className='text-gray-700 font-medium'>
            {t(
              'calculationDetailsPage.sections.injectionMoldingProcess.auxiliaryEquipments.cycleTime',
            )}
          </span>
          <span className='text-lg'>{machine.operation_value} s</span>
        </div>
      )}
    </div>
  );
};

export default AuxiliaryEquipmentValues;
